import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

export const workEventSlice = createSlice({
  name: "workEvent",
  initialState,
  reducers: {
    reset: () => initialState,
    setWorkEvent: (state, action) => {
      state[action.payload.id] = action.payload;
    },
    setWorkEventStatus: (state, action) => {
      state[action.payload.id] = {
        ...state[action.payload.id],
        status: action.payload.status,
      };
    },
  },
});
